<template>
  <v-dialog v-model="dialog" max-width="960" scrollable persistent>
    <v-card class="shadowCard">
      <v-card-title class="text-subtitle-1 flex-wrap">
        <span class="mr-2">Sucursal origen</span>
        <v-spacer />
        <div class="d-flex flex-wrap align-center" style="max-width: 100%">
          <v-select
            v-model="filtroSucursal"
            :items="opcionesFiltroSucursal"
            label="Filtrar sucursal"
            filled
            dense
            hide-details
            clearable
            class="mr-2 mb-1"
            style="min-width: 180px; max-width: 240px"
            :menu-props="{ maxHeight: 280 }"
          />
          <v-btn
            small
            tile
            outlined
            color="primary"
            class="mr-2 mb-1"
            :disabled="filtroSucursal == null || filtroSucursal === ''"
            @click="mostrarTodo"
          >
            <v-icon small left>mdi-filter-off-outline</v-icon>
            Mostrar todo
          </v-btn>
          <v-btn small tile color="primary" dark class="mr-2 mb-1" @click="abrirAgregar">
            <v-icon small left>mdi-plus</v-icon>
            Agregar nuevo
          </v-btn>
          <v-btn small tile text class="mb-1" @click="cerrar">
            <v-icon small left>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </div>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <v-alert v-if="errorLista" type="error" dense outlined class="mb-3">{{ errorLista }}</v-alert>
        <v-alert v-if="!opcionesSucursalCdr.length && !nombresPlanteles.length" type="info" dense text class="mb-3">
          Consulta primero CDR o elige escuela con planteles activos para poder agregar.
        </v-alert>
        <v-alert v-else-if="!opcionesSucursalCdr.length" type="info" dense text class="mb-3">
          Aún no hay CDR de estas sucursales. Puedes asignar responsable con el plantel activo; al bajar llamadas se vincularán.
        </v-alert>
        <div v-if="filtroSucursal" class="text-caption grey--text mb-2">
          Vista filtrada: {{ filtroSucursal }} (posición 1, 2, 3… dentro de esta sucursal)
        </div>

        <v-data-table
          dense
          elevation-0
          item-key="id"
          :headers="headers"
          :items="filasFiltradas"
          :loading="cargando"
          class="elevation-0"
        >
          <template v-slot:item.actions="{ item }">
            <v-btn
              small
              tile
              color="primary"
              dark
              :loading="guardandoId === item.id"
              @click="abrirEditar(item)"
            >
              <v-icon small left>mdi-pencil</v-icon>
              Actualizar información
            </v-btn>
          </template>

          <template v-slot:no-data>
            <div class="grey--text py-4 text-center">
              Sin asignaciones{{ filtroSucursal ? ' para esta sucursal' : '' }}. Usa «Agregar nuevo».
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Formulario agregar / editar responsable -->
    <v-dialog v-model="dialogForm" max-width="480" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ editando ? 'Actualizar información' : 'Agregar nuevo' }}
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-select
                v-model="form.sucursal"
                :items="opcionesSucursalForm"
                label="Sucursal"
                filled
                dense
                hide-details
                :disabled="editando"
                :menu-props="{ maxHeight: 280 }"
              />
            </v-col>
            <v-col cols="12">
              <v-combobox
                v-model="form.origen"
                :items="opcionesOrigenForm"
                label="Origen (extensión)"
                filled
                dense
                hide-details
                :disabled="editando"
                :menu-props="{ maxHeight: 280 }"
                hint="Si no hay CDR aún, escribe la extensión (ej. 1000)"
                persistent-hint
              />
            </v-col>
            <v-col v-if="!editando" cols="12">
              <v-text-field
                :value="siguientePosicionPreview"
                label="Posición (automática por sucursal)"
                filled
                dense
                hide-details
                readonly
                disabled
              />
            </v-col>
            <v-col v-if="editando" cols="12">
              <v-text-field
                :value="form.posicion"
                label="Posición"
                filled
                dense
                hide-details
                readonly
                disabled
              />
            </v-col>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.responsable"
                :items="opcionesResponsable"
                item-text="nombre"
                item-value="nombre"
                label="Responsable de la línea (vendedora)"
                filled
                dense
                hide-details
                clearable
                :disabled="!form.sucursal"
                :loading="cargandoVendedoras"
                :menu-props="{ maxHeight: 320 }"
                :no-data-text="textoSinVendedoras"
                :placeholder="form.sucursal ? 'Buscar vendedora de la sucursal…' : 'Selecciona sucursal primero'"
              />
              <div v-if="form.sucursal" class="text-caption grey--text mt-1">
                Mostrando vendedoras de: {{ form.sucursal }}
              </div>
            </v-col>
          </v-row>
          <v-alert v-if="errorForm" type="error" dense outlined class="mt-3 mb-0">{{ errorForm }}</v-alert>
          <v-alert v-if="editando" type="info" dense text class="mt-3 mb-0">
            Al cambiar el responsable, las llamadas ya bajadas conservan el anterior; las nuevas usarán el nuevo.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn small tile text :disabled="guardando" @click="dialogForm = false">Cancelar</v-btn>
          <v-btn small tile color="primary" dark :loading="guardando" @click="guardarForm">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogSucursalOrigen',

  props: {
    value: { type: Boolean, default: false },
    /** Filas CDR cargadas (plantel + src) para armar catálogos de sucursal/origen. */
    cdrRecords: { type: Array, default: () => [] },
    /** Planteles activos (filtro escuela) para poder asignar aunque aún no haya CDR. */
    planteles: { type: Array, default: () => [] }
  },

  data () {
    return {
      cargando: false,
      cargandoVendedoras: false,
      guardando: false,
      guardandoId: null,
      filas: [],
      /** Catálogo de nombres con rol vendedora (puestos 18, 73, 78). */
      vendedoras: [],
      filtroSucursal: null,
      errorLista: '',
      errorForm: '',
      dialogForm: false,
      editando: false,
      form: {
        id: null,
        sucursal: null,
        origen: null,
        posicion: null,
        responsable: ''
      },
      headers: [
        { text: 'Sucursal', value: 'sucursal' },
        { text: 'Origen', value: 'origen' },
        { text: 'Posición', value: 'posicion', width: '90' },
        { text: 'Responsable de la línea', value: 'responsable' },
        { text: '', value: 'actions', sortable: false, width: '210', align: 'center' }
      ]
    }
  },

  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    /** Sucursales únicas de la tabla CDR (plantel). */
    opcionesSucursalCdr () {
      const set = new Set()
      for (const r of this.cdrRecords || []) {
        const s = this.valorSucursalCdr(r)
        if (s) set.add(s)
      }
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
    },
    /** Nombres de planteles activos (p. ej. APODACA MM) aunque no haya CDR aún. */
    nombresPlanteles () {
      const set = new Set()
      for (const p of this.planteles || []) {
        const n = p && (p.plantel || p.nombre) != null
          ? String(p.plantel || p.nombre).trim()
          : ''
        if (n) set.add(n)
      }
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
    },
    /** Sucursales ya guardadas + CDR + planteles activos para el filtro. */
    opcionesFiltroSucursal () {
      const set = new Set(this.opcionesSucursalCdr)
      for (const n of this.nombresPlanteles) set.add(n)
      for (const f of this.filas || []) {
        const s = f && f.sucursal != null ? String(f.sucursal).trim() : ''
        if (s) set.add(s)
      }
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
    },
    /** En alta: CDR + planteles + filtro activo. */
    opcionesSucursalForm () {
      const set = new Set(this.opcionesSucursalCdr)
      for (const n of this.nombresPlanteles) set.add(n)
      if (this.filtroSucursal) set.add(this.filtroSucursal)
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
    },
    filasFiltradas () {
      const suc = this.filtroSucursal != null ? String(this.filtroSucursal).trim() : ''
      let rows = this.filas || []
      if (suc) {
        rows = rows.filter((r) => String(r.sucursal || '').trim() === suc)
      }
      return rows.slice().sort((a, b) => {
        const sa = String(a.sucursal || '').localeCompare(String(b.sucursal || ''), 'es')
        if (sa !== 0) return sa
        return (Number(a.posicion) || 0) - (Number(b.posicion) || 0)
      })
    },
    /** Preview de la siguiente posición dentro de la sucursal elegida. */
    siguientePosicionPreview () {
      const suc = this.form.sucursal != null ? String(this.form.sucursal).trim() : ''
      if (!suc) return '—'
      let max = 0
      for (const r of this.filas || []) {
        if (String(r.sucursal || '').trim() !== suc) continue
        const p = Number(r.posicion) || 0
        if (p > max) max = p
      }
      return max + 1
    },
    /** Orígenes (src) filtrados por sucursal elegida al agregar. */
    opcionesOrigenForm () {
      if (this.editando && this.form.origen) {
        return [this.form.origen]
      }
      const suc = this.form.sucursal
      const set = new Set()
      for (const r of this.cdrRecords || []) {
        if (suc && this.valorSucursalCdr(r) !== suc) continue
        const o = this.valorOrigenCdr(r)
        if (o) set.add(o)
      }
      return Array.from(set).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }))
    },
    /** Lista única de vendedoras de la sucursal del form (alta o edición). */
    opcionesResponsable () {
      const suc = this.form.sucursal != null ? String(this.form.sucursal).trim() : ''
      if (!suc) return []

      const map = new Map()
      for (const v of this.vendedoras || []) {
        if (!this.vendedoraPerteneceASucursal(v, suc)) continue
        const nombre = v && v.nombre != null ? String(v.nombre).trim() : ''
        if (!nombre) continue
        const key = nombre.toLowerCase()
        if (!map.has(key)) {
          map.set(key, {
            nombre,
            iderp: v.iderp,
            plantel: v.plantel || ''
          })
        }
      }
      // Si ya hay responsable guardado y no aparece en catálogo, se mantiene al editar
      const actual = this.form.responsable != null ? String(this.form.responsable).trim() : ''
      if (this.editando && actual && !map.has(actual.toLowerCase())) {
        map.set(actual.toLowerCase(), { nombre: actual, iderp: null, plantel: suc })
      }
      return Array.from(map.values()).sort((a, b) =>
        a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      )
    },
    textoSinVendedoras () {
      if (!this.form.sucursal) return 'Selecciona una sucursal primero'
      if (this.cargandoVendedoras) return 'Cargando…'
      return 'No hay vendedoras asignadas a esta sucursal'
    }
  },

  watch: {
    value (open) {
      if (open) {
        this.cargarLista()
        this.cargarVendedoras()
      }
    },
    'form.sucursal' (nueva, anterior) {
      if (!this.editando) {
        const ok = this.opcionesOrigenForm.includes(this.form.origen)
        if (!ok) this.form.origen = null
      }
      // Si cambia la sucursal y el responsable ya no pertenece, limpia
      if (!this.editando && nueva !== anterior && this.form.responsable) {
        const sigue = this.opcionesResponsable.some(
          (v) => String(v.nombre).toLowerCase() === String(this.form.responsable).toLowerCase()
        )
        if (!sigue) this.form.responsable = null
      }
    }
  },

  methods: {
    valorSucursalCdr (r) {
      if (!r) return ''
      const s = r.plantel != null ? String(r.plantel).trim() : ''
      if (s) return s
      const alt = r.sucursal || r.sucursal_nombre || r.nombre_sucursal || r.branch || ''
      return alt != null ? String(alt).trim() : ''
    },
    valorOrigenCdr (r) {
      if (!r || r.src == null) return ''
      return String(r.src).trim()
    },
    normTxt (s) {
      return String(s || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },
    /**
     * CDR usa nombre de plantel (p. ej. CUITLAHUAC); vendedoras.list trae `plantel` del catálogo KPI.
     * Coincide por igualdad, contención o acrónimo.
     */
    vendedoraPerteneceASucursal (v, sucursal) {
      if (!v || !sucursal) return false
      const suc = this.normTxt(sucursal)
      if (!suc) return false
      const candidatos = [
        v.plantel,
        v.acronimo,
        v.nombre_plantel,
        v.plantel_nombre
      ]
      for (const c of candidatos) {
        if (c == null || String(c).trim() === '') continue
        // nombre_plantel a veces es "PLANTEL / Persona"
        const partePlantel = String(c).split('/')[0]
        const p = this.normTxt(partePlantel)
        if (!p) continue
        if (p === suc) return true
        if (p.indexOf(suc) !== -1 || suc.indexOf(p) !== -1) return true
      }
      return false
    },
    mostrarTodo () {
      this.filtroSucursal = null
    },
    cerrar () {
      this.dialog = false
    },
    async cargarVendedoras () {
      this.cargandoVendedoras = true
      try {
        const { data } = await this.$http.get('vendedoras.list')
        this.vendedoras = Array.isArray(data) ? data : []
      } catch (e) {
        this.vendedoras = []
        console.warn('[DialogSucursalOrigen] vendedoras.list', e)
      } finally {
        this.cargandoVendedoras = false
      }
    },
    async cargarLista () {
      this.cargando = true
      this.errorLista = ''
      try {
        const { data } = await this.$http.get('telefonia.sucursal.origen.list')
        this.filas = Array.isArray(data) ? data : []
      } catch (e) {
        this.filas = []
        this.errorLista =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          'Error al cargar asignaciones'
      } finally {
        this.cargando = false
      }
    },
    async abrirAgregar () {
      this.editando = false
      this.errorForm = ''
      if (!this.vendedoras.length && !this.cargandoVendedoras) {
        await this.cargarVendedoras()
      }
      const sucPref =
        (this.filtroSucursal != null && String(this.filtroSucursal).trim() !== ''
          ? String(this.filtroSucursal).trim()
          : null) ||
        this.opcionesSucursalForm[0] ||
        null
      this.form = {
        id: null,
        sucursal: sucPref,
        origen: null,
        posicion: null,
        responsable: null
      }
      this.$nextTick(() => {
        if (this.opcionesOrigenForm.length) {
          this.form.origen = this.opcionesOrigenForm[0]
        }
      })
      this.dialogForm = true
    },
    async abrirEditar (item) {
      this.editando = true
      this.errorForm = ''
      if (!this.vendedoras.length && !this.cargandoVendedoras) {
        await this.cargarVendedoras()
      }
      this.form = {
        id: item.id,
        sucursal: item.sucursal,
        origen: item.origen,
        posicion: item.posicion,
        responsable: item.responsable || null
      }
      this.dialogForm = true
    },
    async guardarForm () {
      this.errorForm = ''
      const responsable = String(this.form.responsable || '').trim()
      if (!responsable) {
        this.errorForm = 'Selecciona la vendedora responsable'
        return
      }
      if (!this.editando) {
        if (!this.form.sucursal || !this.form.origen) {
          this.errorForm = 'Sucursal y origen son obligatorios'
          return
        }
      }

      this.guardando = true
      this.guardandoId = this.form.id
      try {
        if (this.editando) {
          await this.$http.post('telefonia.sucursal.origen.update', {
            id: this.form.id,
            responsable
          })
          this.$emit('success', 'Responsable actualizado')
        } else {
          await this.$http.post('telefonia.sucursal.origen.add', {
            sucursal: this.form.sucursal,
            origen: this.form.origen,
            responsable
          })
          this.filtroSucursal = this.form.sucursal
          this.$emit('success', 'Asignación creada')
        }
        this.dialogForm = false
        await this.cargarLista()
      } catch (e) {
        this.errorForm =
          (e.response && e.response.data && e.response.data.message) ||
          e.message ||
          'No se pudo guardar'
      } finally {
        this.guardando = false
        this.guardandoId = null
      }
    }
  }
}
</script>
